<template>
  <v-select2
    :id="id"
    :options="options"
    :value="value"
    :required="required"
    :disabled="disabled"
    :settings="comboSettings"
    @change="update"
  />
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: String,
      default: () => {
        return "combo-" + self.crypto.randomUUID();
      },
    },
  },
  computed: {
    comboSettings() {
      const options = {
        placeholder: this.placeholder,
        theme: "bootstrap",
        language: "es",
        width: "100%",
        minimumResultsForSearch: 4,
      };

      if (this.url != "") {
        options.ajax = {
          url: this.getAjaxUrl,
          method: "POST",
          xhrFields: {
            withCredentials: true,
          },
          processResults: function (response) {
            let items = [];

            if ("results" in response) {
              items = response.results;
            }

            if ("items" in response) {
              items = response.items;
            }

            const results = items.map(function (item) {
              if ("value" in item) {
                return { id: item.value, text: item.text };
              }
              return item;
            });

            return { results: results };
          },
          dataType: "json",
          delay: 250,
        };
      }

      return options;
    },
  },
  data() {
    return {
      valuemut: this.value,
    };
  },
  methods: {
    update(value) {
      this.valuemut = value;
      this.$emit("input", this.valuemut);
    },
    getAjaxUrl() {
      return process.env.VUE_APP_ENDPOINT + this.url;
    },
  },
};
</script>
